const config = {
  API_URL: process.env.REACT_APP_API_URL,
  URL_BASE:  process.env.REACT_APP_URL_BASE || '/',
  SITE_TITLE:  process.env.REACT_APP_SITE_TITLE || 'Teleporteo',
  SOCKET_URL:  process.env.SOCKET_URL || 'wss://solexx.mx',
}

export default config;